import React from 'react'
import { styled } from '@mui/material/styles'
import { useRecoilValue } from 'recoil'
import { Backdrop, CircularProgress } from '@mui/material/'
import { loadingState } from '@store/atoms/loading'

const PREFIX = 'BackdropCircularProgress'

const classes = {
  backdrop: `${PREFIX}-backdrop`,
}

const StyledBackdrop = styled(Backdrop)(({ theme }) => ({
  [`&.${classes.backdrop}`]: {
    color: '#fff',
    zIndex: theme.zIndex.modal + 1,
  },
}))

export function BackdropCircularProgress() {
  const loading = useRecoilValue(loadingState)

  if (!loading.isLoading) {
    return null
  }

  return (
    <StyledBackdrop className={classes.backdrop} open={loading.isLoading}>
      <CircularProgress color="primary" />
    </StyledBackdrop>
  )
}
